const USER_ACTION_TYPES = {
  SET_TOKEN: 'SET_TOKEN',
  SET_USER: 'SET_USER',
  RESET_USER: 'RESET_USER',
  SET_USER_PERMISSION: 'SET_USER_PERMISSION',
};

export default USER_ACTION_TYPES;
